import React, { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import { useDispatch, useSelector } from 'react-redux';
import tableCustomStyles from '../../components/common/CustomeStyle';
import ActionMenu from '../../components/common/ActionMenu/ActionMenu';
import { jobProfileActions } from '../../actions';
import useModal from '../../components/Hooks/useModal';
import ReferredProfileModal from '../../components/common/Modal/ReferredProfileModal';




const ReferralJobProfile = () => {
  const [columns, setColumns] = useState([]);
  const [profileData, setProfileData] = useState([]);
  const [candidateId, setCandidateId] =useState([])
  const dispatch = useDispatch();
  const getReferralProfile = useSelector((state) => state.jobProfiles.referralData);
  const user = useSelector((state) => state.authentication.user);
  const { toggle: referredProfileToggle, visible: referredProfileVisible } = useModal();

  const handleResumeClick = (resumeUrl) => {
    window.open(resumeUrl, '_blank');
  };

  useEffect(() => {
    dispatch(jobProfileActions.getAllReferral());  
  }, [])
  
  useEffect(() => {
    if (getReferralProfile) {
      const referralProfiles = getReferralProfile || [];
      setProfileData(referralProfiles);
    }
  }, [getReferralProfile]);

  useEffect(() => {
    setColumns([
      {
        cell: (row) => <span></span>,
        allowOverflow: true,
        width: '20px',
      },
      {
        name: 'Name',
        selector: (row) => row?.name,
        sortable: false,
        grow: 2,
        style: {
          cursor: 'default',
        },
      },
      {
        name: 'Job Title',
        selector: (row) => row?.referralJobTitle,
        sortable: false,
        grow: 2,
        style: {
          cursor: 'default',
        },
      },
      {
        name: 'Job Profile',
        selector: (row) => row?.referralJobProfile,
        sortable: false,
        grow: 2,
        style: {
          cursor: 'default',
        },
      },
      {
        name: 'Phone No',
        selector: (row) => (
          <a href={`tel:${row?.phone}`} style={{ textDecoration: 'none' }}>
            {row?.phone}
          </a>
        ),
        sortable: false,
        grow: 2,
        style: {
          cursor: 'default',
        },
      },
      {
        name: 'Email',
        selector: (row) => (
          <a href={`mailto:${row?.email}`} style={{ textDecoration: 'none' }}>
            {row?.email}
          </a>
        ),
        sortable: false,
        grow: 2,
        style: {
          cursor: 'default',
        },
      },
      {
        name: 'Referred By',
        selector: (row) => row?.referralBy.name,
        sortable: false,
        grow: 2,
        style: {
          cursor: 'default',
        },
      },
      {
        name: 'Resume',
        cell: (row) => (
          <span
            style={{ cursor: 'pointer', color: 'blue' }}
            onClick={() => handleResumeClick(row.resume.url)}
          >
            View Resume
          </span>
        ),
        sortable: false,
        grow: 2,
      },
      {
        cell: (row) => (
          user && user.userRole !== 4 ? (
            <ActionMenu
              size='small'
              type='openings'
              row={row}
              referredProfile={true}
              setCandidateId={setCandidateId}
              referredProfileToggle={referredProfileToggle}
            />
          ) : null
        ),
        allowOverflow: true,
        width: '30px',
      }
    ]);
  },[]);

  return (
    <>
      <DataTable
        columns={columns}
        data={profileData}
        customStyles={tableCustomStyles}
        highlightOnHover
        pointerOnHover
        striped
      />
      <ReferredProfileModal
        toggle={referredProfileToggle}
        visible={referredProfileVisible}
        size='md'
        bodyClass='p-0'
        candidateId={candidateId}
      ></ReferredProfileModal>
    </>
  );
};

export default ReferralJobProfile;
